/**
 * Import Dependency
 */
import React, { Component } from 'react'
import { Flex } from 'antd-mobile'
import injectSheet from 'react-jss'
import cx from 'classnames'
import styles from '../assets/styles/components/PageTitle'

/**
 * Import Antd Mobile Design
 */

/**
 * Import Container
 */

/**
 * Declare Variable
 */

/**
 * Component
 */
class PageTitleComponent extends Component {
  /**
     * Render
     */
  render () {
    const { classes, title } = this.props
    const wrapStyle = cx(classes.wrap)
    return (
      <Flex
        className={wrapStyle}
        align='start'
      >
        <Flex.Item>
          {title}
        </Flex.Item>
      </Flex>
    )
  }
};

/**
 * Export
 */
export default injectSheet(styles)(PageTitleComponent)



// WEBPACK FOOTER //
// ./src/components/PageTitle.js